exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/destacados-home/destacados-home.component.css
// module id = ../../../../../src/app/pages/admin/destacados-home/destacados-home.component.css
// module chunks = main